var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0425 30.3912L20.5 26.4963L26.9575 30.4425L25.2662 23.0625L30.955 18.1425L23.4725 17.4762L20.5 10.5062L17.5275 17.425L10.045 18.0912L15.7338 23.0625L14.0425 30.3912ZM7.84125 38.95L11.1725 24.5487L0 14.8625L14.76 13.5812L20.5 0L26.24 13.5812L41 14.8625L29.8275 24.5487L33.1587 38.95L20.5 31.3137L7.84125 38.95Z",
    fill: "#FF6A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuns);
export default __webpack_public_path__ + "static/media/Runs.279a73cb0206fab59a01729fba8ea719.svg";
export { ForwardRef as ReactComponent };